
import React from 'react';
import {Link} from 'react-router-dom';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiPlay, FiCalendar} = FiIcons;

const Hero = () => {
  return (
    <section className="relative bg-gradient-to-br from-brand-purple to-brand-blue py-20 overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-20 left-20 w-32 h-32 border border-brand-lightblue rounded-full"></div>
        <div className="absolute top-40 right-32 w-24 h-24 border border-brand-orange rounded-full"></div>
        <div className="absolute bottom-32 left-1/3 w-16 h-16 border border-brand-rose rounded-full"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="text-center">
          {/* Content */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight max-w-5xl mx-auto">
              Find top engineers for your{' '}
              <br />
              <span className="text-brand-orange">robotics & AI startup</span>{' '}
              <br />
              in weeks, not months
            </h1>
            <p className="text-xl text-brand-lightblue mb-8 leading-relaxed max-w-3xl mx-auto">
              We help fast-scaling robotics and AI companies hire exceptional engineering talent quickly. 
              From computer vision experts to robotics engineers — we find the people who build breakthrough technology.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="https://tidycal.com/trbe/exploration-call"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-brand-orange text-white px-8 py-4 rounded-lg font-semibold hover:bg-secondary-500 transition-colors duration-200 flex items-center justify-center space-x-2 text-lg"
              >
                <SafeIcon icon={FiCalendar} className="h-5 w-5" />
                <span>Book a Call</span>
              </a>
              <Link
                to="/about"
                className="border-2 border-brand-lightblue text-brand-lightblue px-8 py-4 rounded-lg font-medium hover:bg-brand-lightblue hover:text-white transition-colors duration-200 flex items-center justify-center space-x-2"
              >
                <SafeIcon icon={FiPlay} className="h-5 w-5" />
                <span>Learn More</span>
              </Link>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
